module.exports = __webpack_public_path__ + "assets/-_18.01f25d30.svg";